module.exports = new __parcel__URL__("radix-ui-seeklogo.5b78ab6a.svg").toString();